import { useTracking } from '@change-corgi/core/react/tracking';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import type { DecisionMaker } from 'src/app/pages/petitionDetails/shared/types';

import type { AllDmResponses } from '../../../../../hooks/useDecisionMakerCards';

type Result = ModelHookResult<
	{
		dmHasResponded: boolean;
		firstDmResponseUrl: string;
	},
	{
		handleReadResponseClick: () => void;
	}
>;

type UseDmResponseArgs = {
	decisionMaker: DecisionMaker;
	allDmResponses: AllDmResponses;
};

export function useDmResponse({ decisionMaker, allDmResponses }: UseDmResponseArgs): Result {
	const {
		data: {
			petition: { id: petitionId, slug },
		},
	} = usePetitionDetailsPageData();

	const track = useTracking();

	const dmResponses = allDmResponses.filter((response) => response.decisionMaker.id === decisionMaker.id);

	const firstDmResponseUrl = dmResponses.length > 0 ? `/p/${slug}/responses/${dmResponses[0].id}` : '';

	const handleReadResponseClick = () => {
		void track('petition_gamma_read_dm_response_click', {
			petition_id: petitionId,
		});
	};

	return {
		data: {
			dmHasResponded: dmResponses.length > 0,
			firstDmResponseUrl,
		},
		actions: { handleReadResponseClick },
	};
}
